<template>
    <div>
        <!-- 왼쪽메뉴 -->
        <left-navigation 
            :contents="contents"
            :slides='slides | getTitleOnly'
            v-on:goPage="goPage"
        ></left-navigation>

        <!-- 헤더 -->
        <main-header 
            :contents="contents"
            :chapterNumber="chapterNumber"
        ></main-header>

        <!-- 바디 -->
        <main-body 
            :contents="contents"
            v-on:nextPage="nextPage"
            v-on:previousPage="previousPage"
            v-on:goPreviousChapter="goPreviousChapter"
            v-on:goNextChapter="goNextChapter"
        ></main-body>

        <!-- 바텀 -->
        <main-footer 
            :contents="contents"
            v-on:nextPage="nextPage"
            v-on:previousPage="previousPage"
            v-on:goPreviousChapter="goPreviousChapter"
            v-on:goNextChapter="goNextChapter"
        ></main-footer>
    </div>
</template>
<script>
import contentsData from '../../../contents'
export default {
    props: ['chapterNumber'],
    data(){
        return{
            contents : {
                slideNumber : null,
                title : null,
                lectureCode : null,
                chapterCount : null,//chapter total
                chapterId : null,//current chapter Id
                chapterTitle : null,//current chapter title
                currentSlide : null,
                currentSlideCount : null,
                memoBtn : null
            },
            slides : null,
        }
    },
    filters: {
        //pass only needed data to Left & Bottom
        getTitleOnly(originalArray){
            var temp = [];
            _.map(originalArray,(value) => {
                temp.push({'title' : value.title});
            });
            return temp;
        }
    },
    computed:{
        visitCookieName(){
            return 'aw/' + this.contents.lectureCode + '/' + this.contents.chapterId;
        }
    },
    methods:{
        getSlideNumber(){//get Page Number from URL
            let tempUrl = document.URL;
            let tempIndex = tempUrl.indexOf('.htm');
            return parseInt(tempUrl.substring(tempIndex - 2, tempIndex),10); 
        },
        setContentsFromJSON(){
            // 1) set current page number
            this.contents.slideNumber = this.getSlideNumber();

            // 2) set course title & lecture code
            this.contents.title = contentsData.title;
            this.contents.lectureCode = contentsData.lectureCode;

            // 3) set course chapters count
            this.contents.chapterCount = contentsData.chapters.length;

            // 4) set current chapter then current title & current slide
            let chapter = contentsData.chapters[this.chapterNumber - 1];
            if(!chapter){
                swal('알림','챕터정보를 표시할 수 없습니다.','error');
                return;
            }
            this.contents.chapterTitle = chapter.title;
            this.contents.chapterId = parseInt(chapter.id);
            this.contents.currentSlide = chapter.slides[this.contents.slideNumber - 1];
            this.contents.currentSlideCount = chapter.slides.length;

            // 5) set slides total slides
            this.slides = chapter.slides;

            // 6) memo added 2020-07-09
            this.contents.memoBtn = contentsData.memoBtn;

            // 7) navate option 2020-09-17
            this.contents.navigate = contentsData.navigate;
        },
        visitCookieHandler(){
            if($cookies.get(this.visitCookieName) == null || ($cookies.get(this.visitCookieName) < this.contents.slideNumber)){//first visit
                $cookies.set(this.visitCookieName,this.contents.slideNumber);
            }
        },
        goPage(page){
            console.log('AWContents : goPage called');
            // set Visited History
            if(typeof settings.goPage !== 'undefined' && settings.goPage != null){
                return  settings.goPage(this.contents.slideNumber);
            }
            location.href =  "./" + pad(page) + ".html";
        },
        nextPage(value){
            if(typeof settings.nextPage !== 'undefined' && settings.nextPage != null){
                return  settings.nextPage(this.contents.slideNumber);
            }
            this.goPage(this.contents.slideNumber + value);
		},
        previousPage(value){
            if(typeof settings.previousChapter !== 'undefined' && settings.previousPage != null ){
                return settings.previousPage(this.contents.slideNumber);
            }
            this.goPage(this.contents.slideNumber - value);
		},
        goNextChapter(value){
            if(typeof settings.nextChapter !== 'undefined' && settings.nextChapter != null ){
                return settings.nextChapter(this.contents.chapterId);
            }
            location.href =  `../${pad(this.contents.chapterId + 1)}/01.html`;
        },
        goPreviousChapter(value){
            if(typeof settings.previousChapterBtn !== 'undefined' && settings.previousChapter != null  ){
                return settings.previousChapter(this.contents.chapterId);
            }
            location.href =  `../${pad(this.contents.chapterId - 1)}/01.html`;
        },
    },
    mounted(){
        this.setContentsFromJSON();
        document.title = this.contents.title;
        this.visitCookieHandler();
    }
}
</script>